// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"158":"labels","496":"campaigns","644":"account","721":"inbox","806":"user"}[chunkId] + "." + {"158":"cceb0c268ed6a12d7129","496":"4a737495aadf619a3d0b","644":"1ccee176e6f4784e7c23","721":"98a4071453fa42ef98b2","806":"3938bf8bc20d2f2971c0"}[chunkId] + ".js";
};